import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setUserBenefitsOptedOut = ({ userBenefitIds }) =>
  call(websocketFetch, 'set_user_benefits_opted_out', {
    user_benefit_ids: userBenefitIds,
  });
